













import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';

const defaultImage = require('@/assets/images/testimonialDefaultImage.png');

export default defineComponent({
  name: 'TestimonialImage',
  props: {
    image: {
      type: String as PropType<string>,
      default: '',
    },
  },
  setup(props) {
    const testimonialImage = computed(() =>
      props.image === '' ? defaultImage : props.image
    );

    return { testimonialImage };
  },
});
